import { apiService } from "../../app.service";

export const checkListsApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch a single checklist
    fetchChecklist: builder.query({
      query: (id) => ({
        url: `/user/checklists/${id}`,
      }),
      providesTags: (result) =>
        result ? [{ type: "Checklist", id: result._id }] : [],
    }),

    // Fetch all checklists
    fetchChecklists: builder.query({
      query: () => ({
        url: "/user/checklists",
      }),
      providesTags: ["Checklists"],
    }),

    // Fetch checklists by type
    fetchChecklistsByType: builder.query({
      query: (type) => ({
        url: "/user/checklists/type/" + type,
      }),
      providesTags: ["ChecklistsByType"],
    }),

    // Create a new checklist
    createChecklist: builder.mutation({
      query: (data) => ({
        url: "/user/checklists",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Checklists", "ChecklistsByType"],
    }),

    // Update an existing checklist
    updateChecklist: builder.mutation({
      query: ({ id, data }) => ({
        url: `/user/checklists/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Checklist", id },
        "ChecklistsByType",
      ],
    }),

    updateChecklistlog: builder.mutation({
      query: ({ id, status }) => ({
        url: `/user/checklistlog/${id}`,
        method: "PUT",
        body: { status },
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Checklist", id }],
    }),

    // Delete a checklist
    deleteChecklist: builder.mutation({
      query: (id) => ({
        url: `/user/checklists/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Checklists", "ChecklistsByType"],
    }),

    // Reorder tasks
    reorderTasks: builder.mutation({
      query: (data) => ({
        url: `/user/checklists/reorder-tasks`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["ChecklistsByType"],
    }),

    //fetch opening checklist status
    fetchOpenChecklistStatus: builder.query({
      query: () => ({
        url: `/user/restaurant/open-checklist`,
      }),
      providesTags: ["openChecklistStatus"],
    }),

    //update opening checklist status
    updateOpenChecklistStatus: builder.mutation({
      query: (data) => ({
        url: `/user/restaurant/open-checklist`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["openChecklistStatus"],
    }),

    //fetch closing checklist status
    fetchCloseChecklistStatus: builder.query({
      query: () => ({
        url: `/user/restaurant/close-checklist`,
      }),
      providesTags: ["closeChecklistStatus"],
    }),

    //update closing checklist status
    updateCloseChecklistStatus: builder.mutation({
      query: (data) => ({
        url: `/user/restaurant/close-checklist`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["closeChecklistStatus"],
    }),

    //fetch hothold checklist status
    fetchHotholdChecklistStatus: builder.query({
      query: () => ({
        url: `/user/restaurant/hothold-checklist`,
      }),
      providesTags: ["hotholdChecklistStatus"],
    }),

    //update hothold checklist status
    updateHotholdChecklistStatus: builder.mutation({
      query: (data) => ({
        url: `/user/restaurant/hothold-checklist`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["hotholdChecklistStatus"],
    }),

    //fetch weekly checklist status
    fetchWeeklyChecklistStatus: builder.query({
      query: () => ({
        url: `/user/restaurant/weekly-checklist`,
      }),
      providesTags: ["weeklyChecklistStatus"],
    }),

    //update weekly checklist status
    updateWeeklyChecklistStatus: builder.mutation({
      query: (data) => ({
        url: `/user/restaurant/weekly-checklist`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["weeklyChecklistStatus"],
    }),

        //fetch monthly checklist status
    fetchMonthlyChecklistStatus: builder.query({
      query: () => ({
        url: `/user/restaurant/monthly-checklist`,
      }),
      providesTags: ["monthlyChecklistStatus"],
    }),

    //update monthly checklist status
    updateMonthlyChecklistStatus: builder.mutation({
      query: (data) => ({
        url: `/user/restaurant/monthly-checklist`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["monthlyChecklistStatus"],
    }),
    
  }),
});

export const {
  useFetchChecklistQuery,
  useFetchChecklistsQuery,
  useCreateChecklistMutation,
  useUpdateChecklistMutation,
  useFetchChecklistsByTypeQuery,
  useDeleteChecklistMutation,
  useUpdateChecklistlogMutation,
  useReorderTasksMutation,
  useFetchOpenChecklistStatusQuery,
  useUpdateOpenChecklistStatusMutation,
  useFetchCloseChecklistStatusQuery,
  useUpdateCloseChecklistStatusMutation,
  useFetchHotholdChecklistStatusQuery,
  useUpdateHotholdChecklistStatusMutation,
  useFetchWeeklyChecklistStatusQuery,
  useUpdateWeeklyChecklistStatusMutation,
  useFetchMonthlyChecklistStatusQuery,
  useUpdateMonthlyChecklistStatusMutation,
} = checkListsApi;
